import styled from "@emotion/styled"

const Divider = styled.div`
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
`

export default Divider
